import DashboardLayout from "../../lib/components/layouts/dashboard";
import PatientConfirmTherapySession from "../../lib/components/therapysession/patient/patient-confirm-therapy-session";
import { useContext } from "react";
import { AppContext } from "lib/contexts/app-context";
import { isPatientUser } from "lib/utils/util";
import { PAGE_ROUTES } from "lib/constants/page-routes";

const PatientConfirmTherapySessionPage = () => {
  const { appState } = useContext(AppContext);

  const BreadcrumbItems = [
    {
      label: "Dashboard",
      path: isPatientUser(appState?.userRole)
        ? PAGE_ROUTES.PATIENT.Dashboard
        : PAGE_ROUTES.ADMIN.Dashboard,
    },
    {
      label: "Book Therapy Session",
      path: isPatientUser(appState?.userRole)
        ? PAGE_ROUTES.PATIENT.BookTherapySession
        : PAGE_ROUTES.ADMIN.PatientsManagement,
    },
  ] as BreadcrumbItem[];

  return (
    <DashboardLayout breadcrumbItems={BreadcrumbItems}>
      <PatientConfirmTherapySession />
    </DashboardLayout>
  );
};

export default PatientConfirmTherapySessionPage;
